var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6989 11.7458C9.68102 12.5361 8.40196 13.0067 7.01285 13.0067C3.69312 13.0067 1.00195 10.3189 1.00195 7.00335C1.00195 3.68779 3.69312 1 7.01285 1C10.3326 1 13.0237 3.68779 13.0237 7.00335C13.0237 8.39059 12.5526 9.66794 11.7615 10.6845L14.8031 13.7186C15.0967 14.0115 15.097 14.4867 14.8037 14.7799C14.5105 15.0731 14.0347 15.0734 13.7411 14.7805L10.6989 11.7458ZM11.521 7.00335C11.521 9.49002 9.50264 11.5059 7.01285 11.5059C4.52305 11.5059 2.50468 9.49002 2.50468 7.00335C2.50468 4.51668 4.52305 2.50084 7.01285 2.50084C9.50264 2.50084 11.521 4.51668 11.521 7.00335Z",
    fill: "#868FA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e031f93733c66289533cf5974f35799b.svg";
export { ForwardRef as ReactComponent };